/* panel-title.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._39xV029DVM%7Bwidth%3A1.5rem%7D%0A._0jFU0V9DVM%7Bheight%3A1.5rem%7D");






import type { ReactNode } from 'react';
import Heading from '@atlaskit/heading/heading';
import { Box } from '@atlaskit/primitives/compiled/box';
export interface PanelTitleProps {
  /**
   * The title text content.
   */
  children: ReactNode;
  /**
   * Optional icon to display alongside the title.
   */
  icon?: ReactNode;
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
}
const styles = {
  title: "_3iDTPbQ4SZ _0hPCNLDIqT _2O5Vij7dHp",
  titleText: "_0LQT5E1Y8M",
  icon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM"
};

/**
 * The PanelTitle component provides a standardized title display for panels
 * with optional icon support and consistent typography.
 */
export function PanelTitle({
  children,
  icon,
  testId
}: PanelTitleProps): JSX.Element {
  return <Box testId={testId} xcss={styles.title}>
			{icon && <Box xcss={styles.icon}>{icon}</Box>}
			<span className={ax([styles.titleText])}>
				<Heading size="small" as="h2">
					{children}
				</Heading>
			</span>
		</Box>;
}